<template>
  <el-row class="service-content" v-loading="isLoading">
    <el-col>
      <table style="width: 100%;">
        <tr>
          <td>
            <h5>{{dataModel.ServiceName}}</h5>
          </td>
          <td style="text-align: right;">
            <span>项目主负责人：</span>
            <span v-if="!isReadonly">
              <el-select placeholder="未分配" filterable v-model="dataModel.ResponsiblePersonId" size="medium" style="margin-left: 5px;">
                <el-option v-for="item in employeeList" :key="item.Id" :label="getEmployeeNameById(item.Id)" :value="item.Id" />
              </el-select>
              <el-button type="primary" size="medium" :disabled="!haveChanges" style="margin-left: 5px;" @click="onSaveClick">保存</el-button>
              <el-button size="medium" :disabled="!haveChanges" style="margin-left: 5px;" @click="onResetClick">重置</el-button>
            </span>
            <span v-else>{{getEmployeeNameById(dataModel.ResponsiblePersonId)}}</span>
          </td>
        </tr>
      </table>
    </el-col>
    <el-col>
      <el-table row-key="Id" :header-cell-style="{'background-color': 'rgb(227,227,227)'}" :row-style="{'background-color': 'whitesmoke'}"
        :cell-style="{'border-bottom': 0}" :data="dataModel.ServiceItemList">
        <el-table-column prop="ServiceItemName" label="项目名称" min-width="160" />
        <el-table-column label="项目报名日期" min-width="120" :formatter="dateFormatter">
          <template #default="{row, $index, column}">
            {{dateFormatter(row, column, dataModel.CreateTime, $index)}}
          </template>
        </el-table-column>
        <el-table-column prop="EndDate" label="项目截止日期" min-width="120" :formatter="dateFormatter" />
        <el-table-column label="项目剩余" min-width="110">
          <template #default="{row}">
            {{`${row.QuantityTotal !== -1 ? row.QuantityAvailable : '∞'}/${row.QuantityTotal !== -1 ? row.QuantityTotal : '∞'}${GLOBAL.enumSAQuantityType.getDesc(row.QuantityType)}`}}
          </template>
        </el-table-column>
        <el-table-column label="项目跟进人员">
          <template #default="{row}">
            <el-select v-if="!isReadonly" placeholder="未分配" filterable v-model="row.ResponsiblePersonId" size="medium">
              <el-option v-for="item in employeeList" :key="item.Id" :label="getEmployeeNameById(item.Id)" :value="item.Id" />
            </el-select>
            <span v-else>{{getEmployeeNameById(row.ResponsiblePersonId)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>
import global_ from "@/core/global";

import { saveTaskAssignment } from "@/service/studyAbroad.service";

const default_WorkflowService = {
  ServiceName: null,
  WorkflowCurrency: global_.currencyType.CNY,
  ResponsiblePersonId: null,
  ServiceItemList: [],
};

const mixin_generalMethods = {
  methods: {
    dateFormatter(row, column, cellValue, index) {
      let mValue = this.$moment(cellValue);
      if (!mValue.isValid()) return null;

      return mValue.format("YYYY年M月D日");
    },
    getEmployeeNameById(id) {
      let employee = this.employeeList.find((item) => item.Id === id);
      let name = !!employee ? employee.Name : String.empty;
      if (!!employee && employee.Id > 0) {
        name = `${name} (${employee.ResponsibleStudentCount})`;
      }
      return name;
    },
    getOriginalServiceItem(id) {
      return this.originalModel.ServiceItemList.find((item) => item.Id === id);
    },
    getSaveTaskAssignmentData() {
      let ServiceAssignment = {};
      if (
        this.dataModel.ResponsiblePersonId !==
        this.originalModel.ResponsiblePersonId
      ) {
        ServiceAssignment[this.dataModel.Id] =
          this.dataModel.ResponsiblePersonId;
      }

      let ServiceItemAssignment = {};
      this.dataModel.ServiceItemList.forEach((item) => {
        let oItem = this.getOriginalServiceItem(item.Id);
        if (item.ResponsiblePersonId !== oItem.ResponsiblePersonId) {
          ServiceItemAssignment[item.Id] = item.ResponsiblePersonId;
        }
      });

      return {
        ServiceAssignment,
        ServiceItemAssignment,
      };
    },
  },
};

export default {
  name: "taskAssignmentServiceCard",
  mixins: [mixin_generalMethods],
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    employeeList: {
      type: Array,
      default: () => [],
    },
    dataIn: {
      type: Object,
      default: () => Object.clone(default_WorkflowService),
    },
  },
  data() {
    return {
      isLoading: false,
      originalModel: Object.clone(this.dataIn),
      dataModel: Object.clone(this.dataIn),
    };
  },
  computed: {
    haveChanges() {
      let value =
        this.dataModel.ResponsiblePersonId !==
        this.originalModel.ResponsiblePersonId;

      if (!value) {
        value = this.dataModel.ServiceItemList.some((item) => {
          let oItem = this.getOriginalServiceItem(item.Id);
          return item.ResponsiblePersonId !== oItem.ResponsiblePersonId;
        });
      }

      return value;
    },
  },
  methods: {
    onSaveClick(e) {
      this.$confirm(
        `您确认要保存该真留服务(${this.dataModel.ServiceName})的任务分配吗?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.isLoading = true;

          let data = this.getSaveTaskAssignmentData();
          saveTaskAssignment(data)
            .then((result) => {
              if (!!result && result.success && result.data) {
                this.$message.success("保存成功");
                this.$emit("saved", this.dataModel);
              } else {
                this.$message.error(result.message);
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        })
        .catch(() => {});
    },
    onResetClick(e) {
      this.dataModel = Object.clone(this.originalModel);
    },
  },
  watch: {
    dataIn(newVal) {
      this.originalModel = Object.clone(this.dataIn);
      this.dataModel = Object.clone(this.dataIn);
    },
  },
};
</script>

<style lang="scss" scoped>
.service-content {
  padding: 20px 0;

  h5 {
    margin-bottom: 0;
    line-height: inherit;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/studyAbroad/taskAssignmentServiceCard.vue